/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import Juego from './Juego';
import {bindActionCreators} from 'redux';
import * as crucigramapalabrasActions from '../../actions/crucigramapalabrasActions';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import * as userActions from '../../actions/userActions';
import * as paginaActions from '../../actions/paginaActions';
 import * as infoActions from '../../actions/infoActions';
import * as menuActions from '../../actions/menuActions';
import { withAuthenticator } from '@aws-amplify/ui-react'
import {Auth} from 'aws-amplify';
import { Segment} from 'semantic-ui-react';
import {usuarioActual} from '../../util';
import toastr from 'toastr';

class Juegos extends React.Component {
    constructor(props, context) {
		
		super(props, context);
       
        this.referencia = React.createRef();
        
        this.state={
            datatmp:{
                across:{},
                down:{}
            },
            
            data:{
              across: {},
              down: {}
            },
            
            dataArray:[
              
            ]
        };
	}
    
   
	componentDidMount(){
        this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);
        this.props.showSidebarIzquierdaActions.onShowSidebarIzquierda(false);
        this.cargarCrucigrama(this.props.idForm);
        
	
    }
    
    
    cargarCrucigrama=(id)=>{
            let user={};
            user.idToken = this.props.user.signInUserSession.idToken.jwtToken;
           this.props.crucigramapalabrasActions.getCrucigrama(id, user).then( palabras=>{
                 
                    this.convert(palabras);
                    
                 });
    }
    
    
    moveLeft=(id,direccion)=>{
        if(direccion=="across")
            this.state.dataArray[id].col = Number(this.state.dataArray[id].col+1);
        else
            this.state.dataArray[id].col = Number(this.state.dataArray[id].col+1);
        this.convert(this.state.dataArray);
        this.savePosition();
    }
    
     moveRight=(id,direccion)=>{
        if(direccion=="across") 
            this.state.dataArray[id].col = Number(this.state.dataArray[id].col-1);
         else
            this.state.dataArray[id].col = Number(this.state.dataArray[id].col-1);
        this.convert(this.state.dataArray);
        this.savePosition();
    }
     
     moveUp=(id,direccion)=>{
        if(direccion=="across")
            this.state.dataArray[id].row = Number(this.state.dataArray[id].row+1);
         else
            this.state.dataArray[id].row = Number(this.state.dataArray[id].row+1);
        this.convert(this.state.dataArray);
        this.savePosition();
    }
    
     moveDown=(id,direccion)=>{
         if(direccion=="across")
            this.state.dataArray[id].row = Number(this.state.dataArray[id].row-1);
         else
            this.state.dataArray[id].row = Number(this.state.dataArray[id].row-1);
         this.convert(this.state.dataArray);
         this.savePosition();
    }
    
    convert=(palabras)=>{
        let datatmp = Object.assign({}, this.state.datatmp);
        let dataArray=[];
       
        dataArray = palabras;
        
        
        
        for(let i=0; i<dataArray.length;i++){
            
            //console.log(dataArray);
            
            if(dataArray[i].posicion=="across"){
                let tmp = dataArray[i];  
                datatmp.across[eval(dataArray[i].num)] = { clue: tmp.clue, answer: tmp.answer, row: tmp.row, col: tmp.col};
            }    
        }
        
        for(let i=0; i<dataArray.length;i++){
            if(dataArray[i].posicion=="down"){
                let tmp = dataArray[i];    
                datatmp.down[eval(dataArray[i].num)] = { clue: tmp.clue, answer: tmp.answer, row: tmp.row, col: tmp.col};
            }
        }
        
        this.setState({data:datatmp});
        this.setState({"dataArray":palabras});
        
    } 
    
    savePosition=(event)=>{
        let user={};
            user.idToken = this.props.user.signInUserSession.idToken.jwtToken;
        let dataArray = this.state.dataArray;
        
        this.props.crucigramapalabrasActions.savePosition(dataArray, user).then((palabraGuardada) => {
            //toastr.success("Posiciones guardadas!!!.");
        
        });
        
        
        
    }
    
    seleccionado=(direction, number)=>{
        //console.log("gustavo");
        //console.log(direction);
        //console.log(number);
        
    }
    
    correct=(direction, number, answer)=>{
        //console.log("correcto?");
        //console.log(direction);
        //console.log(number);
        //console.log(answer);
        toastr.success("Respuesta correcta!!!.");
    }
    
    handleChange=(row,column, character)=>{
        //console.log("Cambio");
        //console.log(row);
        //console.log(column);
        //console.log(character); 
    }
    
    render() {
    
        return (
            
          
                  
                <Juego
                    data={this.state.data}
                    dataArray={this.state.dataArray}
                    moveLeft={this.moveLeft}
                    moveRight={this.moveRight}
                    moveDown={this.moveDown}
                    moveUp={this.moveUp}
                    strings={this.props.strings}
                    onSave={this.savePosition}
                    alertCorrect={this.correct}
                    referencia={this.referencia}
                    seleccionado={this.seleccionado}
                    cambio={this.handleChange}
                />
            
              
            
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps){
    return {   
        strings:state.strings,
        idioma:state.idioma,
        menu:state.menu,
        user:state.user
    }

}

function mapDispatchToProps(dispatch){

	return {
        userActions:bindActionCreators(userActions, dispatch),
        menuActions:bindActionCreators(menuActions, dispatch),
        infoActions: bindActionCreators(infoActions, dispatch),
        crucigramapalabrasActions: bindActionCreators(crucigramapalabrasActions, dispatch),
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch)
 	};
}


export default connect (mapStateToProps, mapDispatchToProps)(withAuthenticator(Juegos));